"use client";

import { toast } from "@/app/_providers/toast";
import { cn } from "@ui/lib/utils";
import { RotateCcwIcon } from "lucide-react";
import { useTranslations } from "next-intl";

import { resetPreset } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { SoundBoardButton } from "./SoundBoardButton";

export const ResetButton = ({ full }: { full?: boolean }) => {
  const { dispatch, state } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");

  const handleReset = () => {
    dispatch(resetPreset({ presetId: state.activePresetId ?? "" }));
    toast.success(t("reset_button.success"));
  };

  return (
    <SoundBoardButton
      className={cn("control-button", !full ? "flex-1" : "aspect-1x1")}
      fixedSize={false}
      onClick={handleReset}
    >
      {full && <RotateCcwIcon className='text-inverse' size={24} />}
      <p className='font-soundboard f-ui-04 w-full truncate text-inverse'>{t("reset_button.label")}</p>
    </SoundBoardButton>
  );
};
